export default function HomeMessage() {
  return null;
}
